import React, {useEffect, useRef, useState} from 'react';
import Layout from '../../../components/layout/Layout';
import {sendData} from "../../../store/actions";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import useSocket from "../../common/useSocket";
import UInput from "../../../common/component/UInput";
import * as Icon from "ubs-icons"
import AppHeader from "../../common/components/app-header";
import Validator from "simple-react-validator";
import {useForceUpdate} from "../../common/useForceUpdate";
import Commonrightcircle from "../../../common/component/RightCircle/commonrightcircle";
import {withRouter} from "../../../common/hocs/routing-hoc";

const ForgotWithRecovery = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [errorMsg, setErrorMsg] = useState("");
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [fieldValue, setFieldValue] = useState({
        identifier: '',
        recoveryCode: '',
    })

    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({
        element: (message, className) => <div className="u_error_message">{message}</div>,
        autoForceUpdate: {forceUpdate}
    }));

    const inputChange = (e) => {
        let {name, value} = e.target;
        value = value.replace(/^\s+/g, '').trim()
        setFieldValue((val) => {
            return {...val, [name]: value}
        })
    }

    const {on, off, refresh} = useSocket(res => {
        setDisabledBtn(false)
        if (!res.error) {
            switch (res.event) {
                case 'forgotPasswordWithRecoveryCode':
                    dispatch({type: 'SET_FORGOT_RECOVERY_USER', payload: res?.data?.user})
                    if (res?.data?.success) history.push(`/reset-with-recovery`)
                    break;
                default:
                    return true;
            }
        } else {
            setErrorMsg(res?.data?.error)
            setTimeout(() => setErrorMsg(res.data.error), 5000)
        }
    })

    const onSubmit = data => {
        data?.preventDefault();
        if (validator?.current?.allValid()) {
            setDisabledBtn(true)
            let params = {
                identifier: fieldValue?.identifier,
                recoveryCode: fieldValue?.recoveryCode,
            }
            sendData(dispatch, 'forgotPasswordWithRecoveryCode', params);
        } else {
            validator?.current?.showMessages()
        }

    }
    useEffect(() => {
        on()
        return () => off();
    }, [])

    const onKeyUp = e => {
        if (e.key === "Enter") {
            onSubmit(e)
        }
    }

    return (
        <React.Fragment>
            <Layout module="forgot">
                <div className="u_account-form">
                    <Commonrightcircle/>
                    <AppHeader header="Forgot Password with Recovery Code?"
                               title="Enter the email address or username linked to your account, along with the recovery code you to reset your password."/>
                    <UInput className='u_mb-20' label="Email Address / User Name" asterisk
                            hasError={validator?.current?.message("identifier", fieldValue?.identifier, "required")}>
                        <input onKeyUp={onKeyUp} type="text" value={fieldValue?.identifier} name="identifier"
                               onChange={inputChange}
                               placeholder=" "/>
                    </UInput>
                    
                    <UInput hasError={validator?.current?.message("recoveryCode", fieldValue?.recoveryCode, "required")}
                            className="u_mb-20" label="Recovery Code" asterisk>
                        <input onChange={inputChange} value={fieldValue?.recoveryCode} type="text" onKeyUp={onKeyUp}
                            name="recoveryCode" placeholder=" " autoComplete="off"/>
                    </UInput>

                    {errorMsg?.length !== 0 && <p className="u_error-message u_mb-15">{errorMsg}</p>}
                    <div className="u_block u_relative">
                        <button disabled={disabledBtn} type="button" onClick={onSubmit}
                                className={`u_account-btn u_w-full u_cp ${disabledBtn && 'u_white'}`}>Verify
                        </button>
                        {disabledBtn && <div className="u_btn-loader"><Icon.Preloader size={70} /></div>}
                    </div>

                </div>
            </Layout>
        </React.Fragment>
    );
}


export default withRouter(ForgotWithRecovery);